export function Logo({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="pin-g" x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ff5663" />
          <stop offset="1" stopColor="#cf1228" />
        </linearGradient>
      </defs>
      <path
        d="M32 9 L52 17 V33 C52 45 43 53 32 56 C21 53 12 45 12 33 V17 Z"
        fill="rgba(255,59,78,0.07)"
        stroke="url(#pin-g)"
        strokeWidth="3.2"
        strokeLinejoin="round"
      />
      <path
        d="M24 24 L32 40 L40 24"
        fill="none"
        stroke="url(#pin-g)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="31" r="2.4" fill="#ff3b4e" />
    </svg>
  );
}
